export default __webpack_public_path__ + "static/media/car-skeleton.076d4ee8.jpg";